module.exports = __webpack_public_path__ + "static/preset-footer-2-22a3ec935e69032241f3f5afdaa2cb5b.png";